export const titleFormatOptions = [
  { value: 'title', label: 'Title' },
  { value: 'brand', label: 'Brand' },
  { value: 'vendor', label: 'Vendor' },
  { value: 'productType', label: 'Product type' },
]

export const titleSeparatorOptions = [
  { value: '-', label: 'Hyphen "-"' },
  { value: '|', label: 'Pipe "|"' },
  { value: '–', label: 'En dash "–"' },
  { value: '—', label: 'Em dash "—"' },
]

export const formatKnownError = (message: string): string => {
  if (!message) return message
  if (message.startsWith('size ')) {
    return message.replace('size', 'File size:')
  }

  if (message.startsWith('AxiosError')) {
    message = message.replace('AxiosError', 'Error')
  }

  const errorIndex = message.indexOf(': ')
  const error = errorIndex === -1 ? message : message.substring(errorIndex + 2)

  if (
    message.includes('Parser has expected a value') ||
    message.includes('incorrect header check') ||
    message.includes('Request failed with status code')
  ) {
    return `Error: source feed not found (${error})`
  }
  if (message.includes('not well-formed')) {
    return `Error: source feed cannot be parsed (${error})`
  }
  if (message === 'Format not supported') {
    return `Error: network format not supported`
  }
  if (message.includes('No products parsed')) {
    return `Error: no valid products (${error})`
  }

  return message
}
